import React, { useMemo } from 'react'

import useSpeakersQuery, { type Speaker } from '../../hooks/useSpeakersQuery'

export type GenericSpeakerListItemProps = {
  speaker: Speaker
}

interface GenericSpeakerListProps {
  filter?: (value: Speaker, index: number, array: Speaker[]) => boolean
  renderItem: (props: GenericSpeakerListItemProps) => React.ReactNode
  placeholder?: string
}

const GenericSpeakerList = ({
  filter = () => true,
  renderItem,
  placeholder,
}: GenericSpeakerListProps) => {
  const { data } = useSpeakersQuery()
  const speakers = useMemo(() => data?.filter(filter), [filter, data])

  return (
    <>
      {speakers && speakers.length > 0
        ? speakers.map((speaker) => renderItem({ speaker }) ?? null)
        : placeholder && <div className="placeholder">{placeholder}</div>}
    </>
  )
}

export default GenericSpeakerList
